import { WHY, COPY } from "@/lib/site";
import { Reveal } from "./Motion";

export const WhyBrands = () => {
  return (
    <section data-testid="why-section" className="bg-ink text-beige py-24 md:py-36">
      <div className="container-editorial">
        <Reveal className="max-w-4xl mb-16 md:mb-24">
          <p className="kicker !text-beige/60 mb-6">{COPY.why.kicker}</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.98] tracking-tight">
            {COPY.why.headingLine1}
            <br />
            <span className="italic text-beige/70">{COPY.why.headingLine2}</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-px">
          {WHY.map((w, i) => (
            <Reveal
              key={w.title}
              delay={(i % 2) * 0.08}
              data-testid={`why-${w.index}`}
              className="flex gap-6 md:gap-10 py-10 border-t border-beige/15"
            >
              <span className="font-display text-3xl md:text-4xl text-beige/40 shrink-0">
                {w.index}
              </span>
              <div>
                <h3 className="font-display text-3xl md:text-[2.1rem] leading-tight">
                  {w.title}
                </h3>
                <p className="mt-3 text-sm md:text-base font-light text-beige/65 leading-relaxed max-w-md">
                  {w.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
